import { ElementType, ReactNode } from "react";
import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "@/animations/motion";
import type { Variants } from "framer-motion";

interface RevealProps {
  children: ReactNode;
  className?: string;
  /** Override the default fade-up variant. */
  variants?: Variants;
  /** Stagger delay in seconds. */
  delay?: number;
  as?: ElementType;
}

const MotionTag = motion.div;

/**
 * Scroll-reveal wrapper. Fades content up once it enters the viewport.
 * Respects prefers-reduced-motion automatically (framer-motion disables
 * transforms when the OS setting is on via the reduced-motion media query
 * handled globally in CSS + hooks).
 */
export function Reveal({
  children,
  className,
  variants = fadeUp,
  delay = 0,
}: RevealProps) {
  return (
    <MotionTag
      className={className}
      variants={variants}
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
      transition={{ delay }}
    >
      {children}
    </MotionTag>
  );
}
